import Vue from 'vue';
import { toggleDropdown } from '../utils/forms';
import Errors from '../classes/Errors'; // eslint-disable-line

Vue.component('enquiries-form-component', {
    props: [
        'contactReasonString',
    ],

    data() {
        return {
            contactReason: null,
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            toggleDropdown
        };
    },

    mounted() {
        this.contactReason = this.contactReasonString;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const type = urlParams.get('type');
        
        if (type === 'brochure') {
            this.contactReason = "Request Brochure";
        }

        const path = this.$el.querySelector('path');
        const length = path.getTotalLength();
        console.log(length);

        turnstile.ready(function () {
            turnstile.render('.cf-turnstile', {
                sitekey: '0x4AAAAAAANGX0RWz79k9x9m',
                callback: function(token) {
                    console.log(`Challenge Success ${token}`);
                },
            });
        });
    },

    methods: {
        setDropdown(event) {
            this[event.target.parentElement.dataset.dropdownName] = event.target.innerHTML;
            this.toggleDropdown(event);
        },

        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios.post(form.action, new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        Vue.nextTick(() => {
                            this.errors.scrollToFirstError(this.$el.querySelector('.form__input--has-error'));
                        });
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    Vue.nextTick(() => {
                        // const successMessage = document.querySelector('.form__success-message');
                        // zenscroll.center(successMessage, 800);
                        window.location.href = "/thank-you";
                    });

                    // window.location = this.$refs.redirectUrl.value;
                    // this.scrollToTop();
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error);
                });
        },
    },
});